import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "shop-form" }
const _hoisted_2 = {
  key: 0,
  class: "phase"
}
const _hoisted_3 = { class: "phasetop" }
const _hoisted_4 = { class: "step" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "load" }
const _hoisted_7 = {
  key: 1,
  class: "phase"
}
const _hoisted_8 = { class: "phasetop" }
const _hoisted_9 = { class: "step" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "load" }
const _hoisted_12 = {
  key: 7,
  class: "expiration-date"
}
const _hoisted_13 = { class: "time" }
const _hoisted_14 = { class: "price" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 10,
  class: "underline"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  href: "https://tekstura.moscow/page/oferta/"
}, "оферту", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  target: "_blank",
  href: "https://tekstura.moscow/page/confidence/"
}, "обработку персональных данных", -1)

import { computed, ref, VueElement, watch } from "vue";
import { useStore } from "vuex";
import getExpirationStringForCertificate from "@/functions/getExpirationStringForCertificate";
import getExpirationStringForAbonement from "@/functions/getExpirationStringForAbonement";

import stepSetReceiver from "@/components/steps/stepSetReceiver.vue";
import stepSetLoyality from "@/components/steps/stepSetLoyality.vue";
import stepSetAdditionalParams from "@/components/steps/stepSetAdditionalParams.vue";
import stepSetDesign from "@/components/steps/stepSetDesign.vue";
import stepForm from "@/components/steps/stepForm.vue";
import stepBuyerForm from "@/components/steps/stepBuyerForm.vue";
import stepAuth from "./steps/stepAuth.vue";
import stepFinish from "./steps/stepFinish.vue";
import {
  IloyalityShopData,
  TypeReceiver,
  TypeSortedLoyalityByName,
  IbyCertificate,
  IbyAbonement,
} from "@/types/typesOfState";
import { TypeLoyalityKinds, TypeLoyaliyMainName } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'shop-form',
  setup(__props) {

const store = useStore();

const currentLoyalityKind = computed(() => store.state.currentLoyalityKind);
const currentShopStep = computed(() => store.state.currentShopStep);
const loyalityShopData = computed(() => store.state.loyalityShopData);
const loyalityTypes = computed(() => store.state.allLoyalityTypes);
const currentBuyLoyalityType = computed(
  () => store.state.loyalityShopData.buyLoyalityType
);

const receiver = computed<TypeReceiver>(
  () => store.state.loyalityShopData.receiver
);

const isNominal = computed(() => store.state.loyalityShopData.isNominal);

const currentBuyLoyality = computed(() => {
  const currentBuy = [
    ...loyalityTypes.value.certificates,
    ...loyalityTypes.value.abonements,
  ].find((i) => i.id === currentBuyLoyalityType.value);

  const expiration =
    currentLoyalityKind.value === "certificate"
      ? getExpirationStringForCertificate(currentBuy)
      : getExpirationStringForAbonement(currentBuy);

  return {
    type: currentBuy,
    expiration: expiration,
  };
});

const currentCertificateData = computed<IbyCertificate>(
  () => store.state.loyalityShopData.byCertificate
);
const currentSortedItemByCertificate = computed<TypeLoyaliyMainName>(
  () =>
    store.state.sortedLoyalityByName.certificates[
      currentCertificateData.value.name || ""
    ]
);
const currentAbonementData = computed<IbyAbonement>(
  () => store.state.loyalityShopData.byAbonement
);
const currentSortedItemByAbonement = computed<TypeLoyaliyMainName>(
  () =>
    store.state.sortedLoyalityByName.abonements[
      currentAbonementData.value.name || ""
    ]
);

const disableNextBtn = computed<boolean>(() => {
  switch (store.state.currentShopStep) {
    case 1:
      if (receiver.value !== null) {
        return false;
      }
      break;
    case 2:
      if (currentLoyalityKind.value === "certificate") {
        if (certificateData.value.name) {
          return false;
        }
      } else if (abonementData.value.name) {
        return false;
      }

      break;
    case 3:
      if (loyalityShopData.value.buyLoyalityType) {
        return false;
      }
      break;
    case 4:
      if (loyalityShopData.value.designType) {
        return false;
      }
      break;
  }
  if (store.state.currentShopStep > 4) {
    return false;
  }
  return true;
});

const currentStepName = computed(() => {
  const isCert: boolean = currentLoyalityKind.value === "certificate";

  let name: string | null | undefined = "";

  switch (store.state.currentShopStep) {
    case 1:
      name = isCert
        ? "Для кого приобретаете сертификат?"
        : "Для кого приобретаете абонемент?";
      break;
    case 2:
      name = isCert ? "Выберите сертификат" : "Выберите абонемент";
      break;
    case 3:
      if (isCert) {
        name =
          currentSortedItemByCertificate.value.title === "Номинал"
            ? "Укажите номинал"
            : "Выберите вариант";
      } else {
        name = "Выберите вариант";
      }
      break;
    case 4:
      name = isCert
        ? "Выберите дизайн сертификата"
        : "Выберите дизайн абонемента";
      break;
    case 5:
      name = "Данные обладателя";
      break;
    case 6:
      name = "Данные покупателя";
      break;
    case 7:
      name = "Подтверждение номера телефона";
      break;
    case 8:
      name = "проверьте данные перед оплатой";
      break;
  }

  return name;
});

const abonementData = computed(() => store.state.loyalityShopData.byAbonement);
const certificateData = computed(
  () => store.state.loyalityShopData.byCertificate
);

const stepClientDataForm = ref<VueElement | null>(null);
const stepBuyerDataForm = ref<VueElement | null>(null);
const stepAuthForm = ref<VueElement | null>(null);
const stepFinishFrom = ref<VueElement | null>(null);

const lastBlockStep = computed<number>(() => store.state.lastBlockStep);

const currentPaymentUrl = computed(
  () => store.state.currentPaymentData?.PaymentURL
);

function nextStep(): void {
  switch (store.state.currentShopStep) {
    case 5:
      if (stepClientDataForm.value.validateClientData()) {
        if (receiver.value === "self") {
          store.state.authModule.authPhone =
            store.state.loyalityShopData.clientData.phone;

          if (!store.state.authModule.tokens) {
            stepAuthForm.value.nextAuthStep(false);
            store.state.currentShopStep += 2;
          } else {
            store.state.currentShopStep += 3;
          }
        } else {
          store.state.currentShopStep++;
        }
      }
      break;
    case 6:
      if (stepBuyerDataForm.value.validateBuyerData()) {
        if (receiver.value === "other") {
          store.state.authModule.authPhone =
            store.state.loyalityShopData.buyerData.phone;

          if (!store.state.authModule.tokens) {
            stepAuthForm.value.nextAuthStep(false);
            store.state.currentShopStep++;
          } else {
            store.state.currentShopStep += 2;
          }
        } else {
          store.state.currentShopStep++;
        }
      }

      break;
    default:
      store.state.currentShopStep++;
  }
}

function prevStep(): void {
  switch (store.state.currentShopStep) {
    case 8:
      if (store.state.authModule.tokens) {
        store.state.currentShopStep -= 3;
      }
      break;
    case 7:
      if (receiver.value === "self") {
        store.state.currentShopStep -= 2;
        store.state.lastBlockStep = 0;
      } else {
        store.state.currentShopStep--;
        store.state.lastBlockStep = 0;
      }
      break;
    case 6:
      if (lastBlockStep.value === 1) {
        store.state.lastBlockStep--;
      }
      if (lastBlockStep.value === 0 || receiver.value === "self") {
        store.state.currentShopStep--;
      }
      break;
    case 4:
      store.state.loyalityShopData.designType = null;
      store.state.currentShopStep--;
      break;
    case 3:
      store.state.loyalityShopData.byAbonement.seanceLength = null;
      store.state.loyalityShopData.byAbonement.seats = null;
      store.state.loyalityShopData.byAbonement.name = null;

      store.state.loyalityShopData.byCertificate.name = null;
      store.state.loyalityShopData.byCertificate.nominal = null;
      store.state.loyalityShopData.byCertificate.seanceLength = null;

      store.state.loyalityShopData.buyLoyalityType = null;

      store.state.currentShopStep--;

      break;
    case 1:
      store.state.currentLoyalityKind = null;
      store.state.currentShopStep--;
      break;
    default:
      store.state.currentShopStep--;
  }
}

function createPayment(): void {
  if (stepFinishFrom.value.validateFinishForm()) {
    store.dispatch("buyLoyality");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (currentShopStep.value <= 8 && (receiver.value === 'self' || receiver.value === null))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(currentShopStep.value >= 6 ? currentShopStep.value - 1 : currentShopStep.value) + "/" + _toDisplayString(_ctx.$store.state.numberOfSteps["self"]), 1),
            _createElementVNode("span", {
              class: "phasename",
              innerHTML: currentStepName.value
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              style: _normalizeStyle({
            width:
              (100 / _ctx.$store.state.numberOfSteps['self']) * currentShopStep.value +
              '%',
          })
            }, null, 4)
          ])
        ]))
      : (currentShopStep.value <= 8 && receiver.value === 'other')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(currentShopStep.value) + "/" + _toDisplayString(_ctx.$store.state.numberOfSteps["other"]), 1),
              _createElementVNode("span", {
                class: "phasename",
                innerHTML: currentStepName.value
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                style: _normalizeStyle({
            width:
              (100 / _ctx.$store.state.numberOfSteps['other']) * currentShopStep.value +
              '%',
          })
              }, null, 4)
            ])
          ]))
        : _createCommentVNode("", true),
    (currentShopStep.value === 1)
      ? (_openBlock(), _createBlock(stepSetReceiver, { key: 2 }))
      : _createCommentVNode("", true),
    (currentShopStep.value === 2)
      ? (_openBlock(), _createBlock(stepSetLoyality, { key: 3 }))
      : _createCommentVNode("", true),
    (currentShopStep.value === 3)
      ? (_openBlock(), _createBlock(stepSetAdditionalParams, { key: 4 }))
      : _createCommentVNode("", true),
    (currentShopStep.value === 4)
      ? (_openBlock(), _createBlock(stepSetDesign, { key: 5 }))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(stepForm, {
      ref_key: "stepClientDataForm",
      ref: stepClientDataForm
    }, null, 512), [
      [_vShow, currentShopStep.value === 5]
    ]),
    _withDirectives(_createVNode(stepBuyerForm, {
      ref_key: "stepBuyerDataForm",
      ref: stepBuyerDataForm
    }, null, 512), [
      [_vShow, currentShopStep.value === 6]
    ]),
    _withDirectives(_createVNode(stepAuth, {
      ref_key: "stepAuthForm",
      ref: stepAuthForm
    }, null, 512), [
      [_vShow, currentShopStep.value === 7]
    ]),
    (currentShopStep.value === 8)
      ? (_openBlock(), _createBlock(stepFinish, {
          key: 6,
          ref_key: "stepFinishFrom",
          ref: stepFinishFrom
        }, null, 512))
      : _createCommentVNode("", true),
    ([3].includes(currentShopStep.value) && currentBuyLoyalityType.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(currentBuyLoyality.value.expiration), 1),
          _createElementVNode("span", _hoisted_14, _toDisplayString(currentLoyalityKind.value === "certificate"
            ? currentBuyLoyality.value.type.balance.toLocaleString()
            : currentBuyLoyality.value.type.cost.toLocaleString()) + " ₽", 1)
        ]))
      : _createCommentVNode("", true),
    (currentShopStep.value <= 8 && !_unref(store).state.currentPaymentData.OrderId)
      ? (_openBlock(), _createElementBlock("div", {
          key: 8,
          class: _normalizeClass(["shop-form__footer", 
        _unref(store).state.isPaymentLoader ? '_loader _loader-40px _loader-left' : ''
      ])
        }, [
          (currentShopStep.value > 0 && !_unref(store).state.currentPaymentData.OrderId)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button back",
                onClick: prevStep
              }, " Назад "))
            : _createCommentVNode("", true),
          (currentShopStep.value < 7)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button next",
                onClick: nextStep,
                disabled: disableNextBtn.value
              }, _toDisplayString(currentShopStep.value === 5 && receiver.value === "self" && !_ctx.$store.getters.isAuth
            ? "Подтвердить"
            : "Продолжить"), 9, _hoisted_15))
            : (currentShopStep.value === 8)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "button next",
                  onClick: createPayment
                }, " Перейти к оплате "))
              : _createCommentVNode("", true)
        ], 2))
      : (currentShopStep.value === 8 && !_unref(store).state.isPaymentSuccess)
        ? (_openBlock(), _createElementBlock("a", {
            key: 9,
            class: "shop-form__footer button next",
            href: currentPaymentUrl.value,
            target: "_parent"
          }, " Перейти к оплате ", 8, _hoisted_16))
        : _createCommentVNode("", true),
    (currentShopStep.value === 8)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createTextVNode(" Нажимая кнопку «Перейти к оплате», вы принимаете "),
          _hoisted_18,
          _createTextVNode(" и предоставляете согласие на "),
          _hoisted_19
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})